// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import { getEntries, media } from '../../../helpers';
import type { Theme } from '../../../types';
import Facet from './facet';
import FilterContainer from '../filterContainer';
import Divider from '../../divider';
import ActiveFiltersContainer from '../activeFilters';

type FacetsStore = {
  [string]: {
    [string]: number,
  },
};

type Props = {
  facets: FacetsStore,
};

const ActiveFilters = styled<typeof ActiveFiltersContainer, Theme, _>(ActiveFiltersContainer)`
  ${media.lg(css`
    display: none;
  `)}
`;

const Facets = ({
  facets,
}: Props) => (
  <FilterContainer>
    <ActiveFilters />
    <Divider />
    {getEntries(facets).map(([category, facet]) => (
      <Facet key={category} name={category} buckets={facet} />
    ))}
  </FilterContainer>
);

export default Facets;
